<template>
    <b-modal id="my-modal" centered hide-header hide-footer body-class="p-0" ref="user-preferences">
        <div class="modal-header bg-primary d-flex justify-content-between">
            <div class="user-modal d-flex flex-row align-items-center">
                <img src="@/assets/img/users/user8.png">
                <p class="text-light m-0 fs-4 ms-2">{{ userName }}</p>
            </div>
            <div class="close-modal d-flex" @click="close">
                <img src="@/assets/img/close.svg">
            </div>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center flex-column">
            <b-form-group label="Mapa:" label-for="layer" style="font-weight: 600;" class="mb-2">
                <b-form-select id="layer" class="form-select" style="cursor: pointer" v-model="selectedLayer" :options="mapLayers" required></b-form-select>
            </b-form-group>
            <div class="item-preferences d-flex flex-row justify-content-center align-items-center my-2">
                <CustomSwitch class="custom-switch" ref="sound-switch" text="Sonido" uniqueId="item-1"></CustomSwitch>
            </div>
            <div class="item-preferences d-flex flex-row justify-content-center align-items-center my-2">
                <CustomSwitch class="custom-switch" ref="show-raster-switch" text="Mostrar Raster" uniqueId="item-2"></CustomSwitch>
            </div>
            <div class="item-preferences d-flex flex-row justify-content-center align-items-center my-2">
                <CustomSwitch class="custom-switch" ref="show-guides-report-switch" text="Guías de Recorrido" uniqueId="item-3"></CustomSwitch>
            </div>
            <b-button type="submit" variant="primary" class="mt-3 w-100" @click="save">Guardar</b-button>
        </div>
    </b-modal>
</template>

<script lang="ts">
import globalModule from '@/store/modules/global.module';
import { Component, Vue, Watch } from 'vue-property-decorator';
import CustomSwitch from '../common/CustomSwitch.vue';
import UserService from '@/api/services/user.service';
import reportsModule from '@/store/modules/reports.module';
import mapsModule from '@/store/modules/maps.module';
import alertsModule from '@/store/modules/alerts.module';

@Component({
    components: { CustomSwitch }
})
export default class UserPreferences extends Vue {
    selectedLayer = 'ostm'

    mapLayers = [
        {
            text: 'OSM',
            value: 'ostm'
        },
        {
            text: 'Satelite',
            value: 'bingmaps'
        }
    ]

    close() {
        const modal: any = this.$refs['user-preferences']
        modal.hide();
    }

    async show() {
        const modal: any = this.$refs['user-preferences']
        await modal.show();

        const soundSwitch: any = this.$refs['sound-switch']
        const showGuidesReport: any = this.$refs['show-guides-report-switch']
        const showRaster: any = this.$refs['show-raster-switch']

        soundSwitch.switchValue = this.getPreference('sound')
        showGuidesReport.switchValue = this.getPreference('showGuidesReport')
        showRaster.switchValue = this.getPreference('showRaster')
    }

    async save() {
        const soundSwitch: any = this.$refs['sound-switch']
        const showGuidesReport: any = this.$refs['show-guides-report-switch']
        const showRaster: any = this.$refs['show-raster-switch']
        let attributes = globalModule.user.attributes
        attributes.preferences.sound = soundSwitch.switchValue
        attributes.preferences.showGuidesReport = showGuidesReport.switchValue
        attributes.preferences.showRaster = showRaster.switchValue
        attributes.preferences.mapLayer = this.selectedLayer
        await UserService.updateAttributes(attributes)
        globalModule.setRaster(showRaster.switchValue)
        reportsModule.setShowGuides(showRaster.switchValue)
        globalModule.setMapLayer(this.selectedLayer)
        alertsModule.setSoundActive(soundSwitch.switchValue)
        this.close()
    }
    
    getPreference(key: string) {
        const preferences = globalModule?.user?.attributes?.preferences
        return preferences[key] ?? true
    }

    get userName() {
        return globalModule.user.name
    }

    get mapLayer() {
        return globalModule.mapLayer
    }

    @Watch("mapLayer", { immediate: false })
    onChangeMapLayer(layer: string): void {
        this.selectedLayer = layer
    }
}

</script>
<style lang="sass">
    .custom-switch
        transform: scale(0.8)

    .modal-header
        height: 60px !important
        .user-modal
            img
                height: 40px !important

    .close-modal
        height: 20px
        cursor: pointer
        transition: all .1s ease
        &:active
            transform: scale(0.9)
        img
            height: 100%

    .modal-container
        position: absolute
        z-index: 999
        width: 100%
        height: 100%
        background: rgb(0 0 0 / 48%)
</style>